import { BellRing } from "lucide-react";
import { PushNotificationsForm } from "@/components/Forms/PushNotificationsForm";
import { NotificationAudience } from "@/components/PushNotifications/notification-audience";

type PushNotificationsPromptProps = {
  onComplete: (success: boolean) => void;
  showHeading?: boolean;
  title?: string;
  audience?: NotificationAudience;
};

export const PushNotificationsPrompt = ({
  onComplete,
  showHeading = true,
  title = "Notifications",
  audience = NotificationAudience.OrganizationMember,
}: PushNotificationsPromptProps) => {
  return (
    <div className="space-y-4">
      {showHeading && (
        <div className="flex items-center">
          <BellRing className="h-6 w-6 mr-3" />
          <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
        </div>
      )}
      <PushNotificationsForm onComplete={onComplete} audience={audience} />
    </div>
  );
};
